export const USERNAME_FIELD = 'user'
export const SETTINGS_FIELD = 'settings'
